module.exports = __webpack_public_path__ + "img/C03-1-Orquidea.16d45282.png";